var React = require('react');

function Notification (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/notification"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"icon/notification","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},[React.createElement("path",{"d":"M31.5,13 L31.5,29 C31.5,32.8659932 28.3659932,36 24.5,36 L8.5,36 C4.63400675,36 1.5,32.8659932 1.5,29 L1.5,13 C1.5,9.13400675 4.63400675,6 8.5,6 L24.5,6","id":"Path","stroke":"#4355F3","strokeWidth":"3","key":0}),React.createElement("circle",{"id":"Oval","stroke":"#4355F3","strokeWidth":"3","cx":"30","cy":"8.5","r":"5.5","key":1})])]);
}

Notification.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = Notification;

Notification.default = Notification;
